export const INIT_WORKSPACE_INFO = 'INIT_WORKSPACE_INFO';
export const UPDATE_WORKSPACE_INFO = 'UPDATE_WORKSPACE_INFO';

export function initWorkspaceInfo(data) {
    return {type: INIT_WORKSPACE_INFO, data};
}

export function updateWorkspaceInfo(data) {
    return {type: UPDATE_WORKSPACE_INFO, data};
}
